// extracted by mini-css-extract-plugin
module.exports = {"container":"HomeSearchSkeleton_container__bTHuD","icon":"HomeSearchSkeleton_icon__YUm7r","text":"HomeSearchSkeleton_text__PKUNU"};